const PHONE_NUMBER_REGEXP = /^\+?[\d -]{8,}$/u

export const directContactFormIsPhoneNumberValid = (value: string): boolean =>
  PHONE_NUMBER_REGEXP.test(value)
